// DS: MO0.2.1
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiData, BuyCoreButtonBiEvent } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';

import s from './CoreMonetizationAd.scss';

interface Props {
  boldText?: string;
  text: string;
  withCTA?: boolean;
}

const CoreMonetizationAd: React.FC<Props> = ({ boldText, text, withCTA }) => {
  const { t } = useTranslation();
  return (
    <div className={s['root']}>
      {boldText && <span className={s['ad-bold-text']}>{boldText}</span>}
      <span className={s['ad-text']}>{text}</span>
      {withCTA && (
        <TextButton
          size="small"
          variant="core-orange"
          href={Url.coreMembershipLink()}
          target="_blank"
          biData={BiData<BuyCoreButtonBiEvent>({
            evid: 375,
            referral_info: ReferralType.SUBSCRIPTIONS_CORE_EXPIRED,
          })}
        >
          {t('coreMonetizationAd.upgradeCTA')}
        </TextButton>
      )}
    </div>
  );
};
CoreMonetizationAd.displayName = 'CoreMonetizationAd';

export default CoreMonetizationAd;
